import { put, call, takeLatest, all, select } from "redux-saga/effects";

import { notification } from "infrastructure/notification";
import { securityMessages } from "ui/screens/security/security.localization";

import { securityRolesActions } from "./SecurityRoles.actions";
import { getSecurityRoles } from "./SecurityRoles.api";
import { ISecurityRolesResponse } from "./SecurityRoles.api.types";
import { ISecurityRolesState, ISecurityRole, ISecurityRolePermission } from "./SecurityRoles.state";

function* loadSecurityRolesExecute() {
  try {
    const state: ISecurityRolesState = yield select((state: { securityRoles: ISecurityRolesState }) => state.securityRoles);
    const tenantId = state.filter?.tenant?.tenantId;

    if (tenantId) {
      const securityRolesResponse: ISecurityRolesResponse[] = yield call(getSecurityRoles, { tenantId: tenantId, accountId: state.filter?.account?.accountId });

      const securityRoles = securityRolesResponse.map<ISecurityRole>(e => ({
        roleId: e.securityRoleId,
        membersNumber: e.numberOfMembers,
        roleName: e.name,
        tenant: {
          tenantId: e.tenantId,
          tenantName: e.tenantName
        },
        permissions: e.permissions.map<ISecurityRolePermission>(i => ({
          name: { messageId: { value: i.name } }
        }))
      }));

      yield put(securityRolesActions.loadSecurityRolesCompleted(securityRoles));
    } else {
      yield put(securityRolesActions.loadSecurityRolesFailed(notification.warning().useMessageId(securityMessages.filter("invalidRequiredFieldState"))));
    }
  } catch (e) {
    yield put(securityRolesActions.loadSecurityRolesFailed(notification.error(e).useMessageId(securityMessages.error("loadSecurityRolesFailed"))));
  }
}

function* applyFilterExecute() {
  yield put(securityRolesActions.loadSecurityRoles());
}

export function* securityRolesSaga() {
  yield all([
    yield takeLatest(securityRolesActions.loadSecurityRoles.toString(), loadSecurityRolesExecute),
    yield takeLatest(securityRolesActions.applyFilter.toString(), applyFilterExecute)
  ]);
}
